module.exports = __webpack_public_path__ + "img/1.dc4e11d4.jpg";